export default {
  computed: {
    distanceOptions() {
      return [
        {
          value: '5',
          text: this.$t(
            'health_actions.scheduling.select_doctor_within_distance_miles',
            [5]
          ),
        },
        {
          value: '10',
          text: this.$t(
            'health_actions.scheduling.select_doctor_within_distance_miles',
            [10]
          ),
        },
        {
          value: '25',
          text: this.$t(
            'health_actions.scheduling.select_doctor_within_distance_miles',
            [20]
          ),
        },
        {
          value: '50',
          text: this.$t(
            'health_actions.scheduling.select_doctor_within_distance_miles',
            [50]
          ),
        },
        {
          value: '100',
          text: this.$t(
            'health_actions.scheduling.select_doctor_within_distance_miles',
            [100]
          ),
        },
      ]
    },
    genderOptions() {
      return [
        {
          value: 'any',
          text: this.$t('health_actions.scheduling.select_doctor_gender_any'),
        },
        {
          value: 'm',
          text: this.$t('health_actions.scheduling.select_doctor_gender_male'),
        },
        {
          value: 'f',
          text: this.$t(
            'health_actions.scheduling.select_doctor_gender_female'
          ),
        },
      ]
    },
  },
}
